var _path, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 64,
    viewBox: "0 0 77 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 3C40.5 1.61929 39.3807 0.5 38 0.5C36.6193 0.5 35.5 1.61929 35.5 3L40.5 3ZM36.2322 53.7678C37.2085 54.7441 38.7915 54.7441 39.7678 53.7678L55.6777 37.8579C56.654 36.8816 56.654 35.2986 55.6777 34.3223C54.7014 33.346 53.1184 33.346 52.1421 34.3223L38 48.4645L23.8579 34.3223C22.8816 33.346 21.2986 33.346 20.3223 34.3223C19.346 35.2986 19.346 36.8816 20.3223 37.8579L36.2322 53.7678ZM35.5 3L35.5 52L40.5 52L40.5 3L35.5 3Z",
    fill: "#1C2650"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 38,
    x2: 2.5,
    y2: 59,
    stroke: "#1C2650",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 76,
    y1: 61.5,
    y2: 61.5,
    stroke: "#1C2650",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 73.5234,
    y1: 38,
    x2: 73.5234,
    y2: 59,
    stroke: "#1C2650",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.afcf3f2f34dfe2a6eed37923b505f0bd.svg";
export { ForwardRef as ReactComponent };